// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"content-wrapper--MGghXar6JMteJw2Q"};